// Tiny fetch wrapper. Always sends/accepts cookies.
// On 401, redirects to /login (preserves return path).

async function request(method, path, body) {
  const res = await fetch(path, {
    method,
    credentials: 'include',
    headers: body == null
      ? { 'Accept': 'application/json' }
      : { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: body == null ? undefined : JSON.stringify(body),
  });

  if (res.status === 401 && !path.startsWith('/api/auth/')) {
    const next = encodeURIComponent(location.pathname + location.search);
    location.href = `/login?next=${next}`;
    throw new Error('unauthorized');
  }

  const ct = res.headers.get('Content-Type') || '';
  const isJSON = ct.includes('application/json');
  const payload = isJSON ? await res.json() : null;

  if (!res.ok) {
    const msg = payload?.error || res.statusText || `HTTP ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    err.payload = payload;
    throw err;
  }
  return payload;
}

export const api = {
  get:    (path)        => request('GET',    path),
  post:   (path, body)  => request('POST',   path, body),
  put:    (path, body)  => request('PUT',    path, body),
  patch:  (path, body)  => request('PATCH',  path, body),
  delete: (path)        => request('DELETE', path),
};
